import React, { useState, useEffect } from "react";
import { Check } from "lucide-react";

export default function FOOMTicker({ items = [] }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % items.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [items.length]);

  if (!items || items.length === 0) return null;

  const current = items[currentIndex];

  return (
    <div
      className="inline-flex items-center gap-4 px-6 py-3 rounded-full"
      style={{
        background: "rgba(249,115,22,0.1)",
        border: "1px solid rgba(249,115,22,0.2)",
        color: "#F97316",
      }}
    >
      <Check size={16} strokeWidth={3} />
      <span className="text-sm font-medium">{current}</span>
      <div className="flex gap-1 ml-2">
        {items.map((_, i) => (
          <div
            key={i}
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: i === currentIndex ? "#F97316" : "rgba(249,115,22,0.2)",
              transition: "background 0.3s ease",
            }}
          />
        ))}
      </div>
    </div>
  );
}
